import { Logo } from './logo'
import { Button } from './ui/button'
import { Link } from '@remix-run/react'

export function Navigation({ isHomePage = false }: { isHomePage?: boolean }) {
	return (
		<nav className="container mx-auto flex items-center justify-between p-4">
			<Logo />
			<Button asChild>
				<Link to="/" className="...">
					Home
				</Link>
			</Button>
			{/* ... resto del código de navegación ... */}
		</nav>
	)
}
